document.addEventListener("DOMContentLoaded", () => {
    const bookBtns = document.querySelectorAll("[data-inquirymodalbtn]");

    if (!bookBtns.length) return;

    // Redirect to inquiry form page when Book a Demo or similar is clicked
    bookBtns.forEach(btn => {
        btn.addEventListener("click", (e) => {
            e.preventDefault();
            const dataValue = e.target.getAttribute('data-inquirymodalbtn');
            if (dataValue === 'downloadbrochure') {
                localStorage.setItem('downloadbrochure', 'true');
            } else {
                localStorage.setItem('downloadbrochure', 'false');
            }
            window.location.href = "inquiry-form.html";
        });
    });

    // Trigger Form  based on query params
    const urlParams = new URLSearchParams(window.location.search);
    const openForm = urlParams.get("openForm");

    // Check if the current page is the homepage
    const isHomepage =
        window.location.pathname === "/" ||
        window.location.pathname === "/index.html";

    if (isHomepage && openForm) {
        localStorage.setItem('downloadbrochure', 'true');
        window.location.href = "inquiry-form.html";
    }
});

